import { getFormValues } from 'redux-form';
import { createSelector } from 'reselect';
import { get } from 'lodash';

import { ACCOUNT_SETUP_FORM_NAME } from 'Common/FormEnum';

import { freeOption } from '../../helpers/AccountSetupConstants';

export const getValidStatusFieldChanged = state =>
  get(state, 'AccountSetupState.validStatusFieldChanged');

export const getValidStatusMessage = state =>
  get(state, 'AccountSetupState.validStatusMessage');

export const getStudentImage = state =>
  get(state, 'AccountSetupState.studentInfo.studentImage');

export const formValueSelector = getFormValues(ACCOUNT_SETUP_FORM_NAME);

export const getValidStatus = createSelector(
  getValidStatusMessage,
  formValueSelector,
  (valid, form) => (form.CEP_Transfer ? freeOption : valid)
);



// WEBPACK FOOTER //
// ./src/pages/accountsetup/state/studentinfo/selector.js